import { getRenderHtml, getSingleReivewHtml } from './ReviewDetailHtmls';

export default class ReviewDetail {
  constructor(htOptions, oModule) {
    this.htOptions = htOptions;
    this.welContainer = htOptions.welContainer;
    this.bShowModifyButtons = htOptions.bShowModifyButtons; // 수정, 삭제 버튼 노출 여부
    this.bUseSlider = htOptions.bUseSlider; // 슬라이더 사용 여부
    this.bShowAddPhotoBtn = htOptions.bShowAddPhotoBtn; // 사진첨부 버튼 노출 여부
    this.oModule = oModule;
    this.nCurrentIndex = 0; // 현재 리뷰 인덱스 (PC only)
    this.NEXT_PAGE_MARGIN_COUNT = 2; // 앞으로 N개의 리뷰가 남았을때 다음 데어터를 호출한다.
    this.bShowed = false; // 리뷰 상세가 노출중인지

    this.setEvent();
  }

  setRecommendCount(nReviewNo, nRecommendCount, bIsCancelRecommend) {
    if (this.wel === undefined) {
      return;
    }

    if (TMON.sDevice === 'PW') {
      const welRecommend = this.welContainer.find(
        `._item[data-reviewNo=${nReviewNo}] [data-role=recommend]`
      );

      welRecommend.find('.text').html(nRecommendCount);

      if (bIsCancelRecommend) {
        welRecommend.removeClass('on');
      } else {
        welRecommend.addClass('on');
      }
    } else {
      // 모바일의 경우 '추천'버튼 하나를 가지고 계속 사용하기 때문에 추천한 슬라이드의 attribute를 업데이트 해주고, 추천 엘리먼트를 업데이트 해줘야한다.
      this.welContainer.find(`._item[data-reviewNo=${nReviewNo}]`).attr({
        'data-recommendCnt': nRecommendCount,
        'data-isRecommended': bIsCancelRecommend ? 'N' : 'Y',
      });
      this.updateRecommendElement();
    }

    if (bIsCancelRecommend) {
      this.showToast('추천이 취소되었습니다');
    } else {
      this.showToast('추천해 주셔서 감사합니다');
    }
  }

  showToast(sText) {
    if (!this.wel || TMON.sDevice === 'PW') {
      return;
    }

    if (!this.welToast) {
      this.welToast = this.wel.find('[data-role=review_toast]');
    }

    this.welToast
      .stop()
      .find('.text')
      .html(sText);
    this.welToast
      .show()
      .delay(2000)
      .fadeOut('slow');
  }

  resetData() {
    if (this.wel === undefined) {
      return;
    }

    if (TMON.sDevice === 'PW') {
      this.wel.find('[data-role="reviewContainer"]').html('');
    } else {
      this.oSwiperReview.removeAllSlides();
    }
  }

  addData(aReview) {
    // 리뷰상세가 보여지지 않고 있고, 아직 한번도 렌더링이 되지 않았을 경우엔 렌더링을 하지 않는다.
    if (this.wel === undefined && this.bShowed === false) {
      return;
    }

    if (this.wel === undefined) {
      // 처음 진입시에 wrapper와 리뷰를 렌더링한다.
      this.wel = this.render();
      this.initReviewSwiper();
      this.appendSlide(this.getReviewSlide(this.oModule.getData())); // 첫 렌더링시 모든 데이터를 렌더링
    } else {
      this.appendSlide(this.getReviewSlide(aReview)); // 처음 렌더링이 아니라면 추가된 데이터만 렌더링
    }

    this.initImageSwiper();
    this.setDisableBtn();
  }

  removeItem(nReviewNo) {
    this.welContainer
      .find(`.review_container[data-reviewNo=${nReviewNo}]`)
      .remove();
    if (TMON.sDevice !== 'PW' && this.bShowed === true) {
      this.updateSwiper();
    }
  }

  appendSlide(sHtml) {
    if (TMON.sDevice === 'PW' || this.bUseSlider === false) {
      this.wel.find('[data-role="reviewContainer"]').append(sHtml);
    } else if (this.oSwiperReview) {
      this.oSwiperReview.appendSlide(sHtml);
    }
  }

  setEvent() {
    if (TMON.sDevice === 'PW') {
      // 이전 리뷰
      this.welContainer.on(
        'click',
        '[data-role=prevReview]',
        this.onPrevReview
      );
      // 다음 리뷰
      this.welContainer.on(
        'click',
        '[data-role=nextReview]',
        this.onNextReview
      );
    }
    // 추천하기
    this.welContainer.on('click', '[data-role=recommend]', this.onRecommend);
    // 신고하기
    this.welContainer.on('click', '[data-role=report]', this.onReport);
    // 수정하기
    this.welContainer.on(
      'click',
      '[data-role=modifyPhotoReview]',
      this.onModify
    );
    // 사진 첨부
    this.welContainer.on('click', '[data-role=addPhoto]', this.onAddPhoto);
    // 삭제하기
    this.welContainer.on(
      'click',
      '[data-role=deletePhotoReview]',
      this.onDelete
    );
    // 구매옵션 펼치기
    this.welContainer.on(
      'click',
      '[data-role=openOptionBtn]',
      this.onOpenOption
    );
    // 딜 링크 클릭
    this.welContainer.on('click', '[data-role=dealLink]', this.onClickDeal);
    // 썸네일 마우스 오버
    this.welContainer.on(
      'mouseover',
      '[data-role=photoOver]',
      this.onMouseOverImage
    );
  }

  clearEvent() {
    if (TMON.sDevice === 'PW') {
      this.welContainer.off('click', '[data-role=prevReview]'); // 이전 리뷰
      this.welContainer.off('click', '[data-role=nextReview]'); // 다음 리뷰
    }
    this.welContainer.off('click', '[data-role=recommend]'); // 추천하기
    this.welContainer.off('click', '[data-role=report]'); // 신고하기
    this.welContainer.off('click', '[data-role=modifyPhotoReview]'); // 수정하기
    this.welContainer.off('click', '[data-role=addPhoto]'); // 사진 첨부
    this.welContainer.off('click', '[data-role=deletePhotoReview]'); // 삭제하기
    this.welContainer.off('click', '[data-role=openOptionBtn]'); // 구매옵션 펼치기
    this.welContainer.off('click', '[data-role=dealLink]'); // 딜 링크 클릭
    this.welContainer.off('mouseover', '[data-role=photoOver]'); // 썸네일 마우스 오버
  }

  onClickDeal = e => {
    const wel = $(e.currentTarget);
    const sTitle = wel.attr('data-title');
    const nDealNo = parseInt(wel.attr('data-dealNo'), 10);
    let nReviewNo = parseInt(wel.parents('._item').attr('data-reviewNo'), 10);

    if (TMON.sDevice !== 'PW') {
      const welActiveSlide = this.bUseSlider
        ? $(this.oSwiperReview.slides[this.oSwiperReview.activeIndex])
        : this.welContainer.find('._item:first');
      nReviewNo = parseInt(welActiveSlide.attr('data-reviewNo'), 10);
    }

    if (this.htOptions.onClickDeal) {
      this.htOptions.onClickDeal(sTitle, nDealNo, nReviewNo);
    }
  };

  onReport = e => {
    const nReviewNo = parseInt(
      $(e.currentTarget)
        .parents('._item')
        .attr('data-reviewNo'),
      10
    );
    if (typeof this.htOptions.onReport === 'function') {
      this.htOptions.onReport(nReviewNo);
    }
  };

  onAddPhoto = e => {
    if ($(e.currentTarget).hasClass('disabled')) {
      // 신고차단 된 경우
      return;
    }

    const nReviewNo = parseInt(
      $(e.currentTarget)
        .parents('._item')
        .attr('data-reviewNo'),
      10
    );
    this.oModule.show('modify', nReviewNo);
    this.hide();

    e.preventDefault();
  };

  onModify = e => {
    /* eslint-disable no-underscore-dangle */
    if (
      TMON.view_mode === 'app' &&
      !TMON.app._isValidAppVersion('4.6.9') &&
      this.htOptions.onModifyFileUploadNotSupportApp
    ) {
      // 4.6.9 버전 이하에서는 Android에서 파일업로드가 안되 기존 callApp을 호출한다.
      this.htOptions.onModifyFileUploadNotSupportApp(
        $(e.currentTarget)
          .parents('._item')
          .attr('data-mainBuyNo')
      );
      return;
    }

    const nReviewNo = parseInt(
      $(e.currentTarget)
        .parents('._item')
        .attr('data-reviewNo'),
      10
    );
    this.oModule.show('modify', nReviewNo);
    this.hide();
  };

  onDelete = e => {
    const wel = $(e.currentTarget).parents('._item:first');
    const nMainBuyNo = parseInt(wel.attr('data-mainBuyNo'), 10);
    const nMainDealNo = parseInt(wel.attr('data-mainDealNo'), 10);
    const nMemberNo = parseInt(wel.attr('data-memberNo'), 10);
    const nReviewNo = parseInt(wel.attr('data-reviewNo'), 10);

    if (typeof this.htOptions.onDelete === 'function') {
      this.htOptions.onDelete(
        nMainBuyNo,
        nMainDealNo,
        nMemberNo,
        nReviewNo,
        this.oModule
      );
    }
  };

  show(nReviewNo) {
    let bFirstRender = false; // 첫렌더링인가?
    this.bShowed = true;
    if (this.wel === undefined) {
      bFirstRender = true;
      this.addData(this.oModule.getData());
    }

    let nMatchReviewIndex = 0;
    let bIsUpdated = false;
    let htFoundReviewData = null;
    if (nReviewNo !== undefined) {
      const htData = this.oModule.getData();
      htData.some((htReview, nIndex) => {
        if (htReview.reviewNo === nReviewNo) {
          nMatchReviewIndex = nIndex;
          bIsUpdated = htReview.bIsUpdated === true;
          htFoundReviewData = htReview;
        }

        return htReview.reviewNo === nReviewNo;
      });
    }

    // 이미 렌더링이 되었을 때 수정 등으로 업데이트가 된 경우 해당 엘리먼트를 다시 그려준다.
    if (bIsUpdated && bFirstRender === false) {
      this.updateSlide(nMatchReviewIndex, htFoundReviewData);
      this.initImageSwiper();
      this.setDisableBtn();
    }

    this.showReviewSlide(nMatchReviewIndex);
    this.wel.show();
    this.setDisableBtn();
    $(window).scrollTop(0);

    if (TMON.sDevice === 'PW') {
      return;
    }

    // 화면에 display 되기를 기다렸다가 swiper를 업데이트 해주어야 제대로 동작하여 timeout을 추가하였다.
    setTimeout(() => {
      this.updateSwiper();
    }, 0);
  }

  updateSwiper() {
    if (this.oSwiperReview) {
      this.oSwiperReview.update();
    }
    if (this.aSwiperImage && Array.isArray(this.aSwiperImage)) {
      this.aSwiperImage.forEach(oSwiper => {
        oSwiper.update();
      });
    }
    this.updateRecommendElement();
  }

  /**
   * 해당 인덱스의 리뷰를 보여준다..
   * @param nIndex
   */
  showReviewSlide(nIndex) {
    this.nCurrentIndex = nIndex;
    if (TMON.sDevice === 'PW' || this.bUseSlider === false) {
      this.wel
        .find('._item')
        .hide()
        .eq(nIndex)
        .show();
    } else {
      this.oSwiperReview.slideTo(nIndex, 0); // 해당 리뷰로 스와이퍼 스크롤
    }
  }

  updateSlide(nIndex, htData) {
    this.wel
      .find('._item')
      .eq(nIndex)
      .find('.review_detail')
      .remove();
    this.wel
      .find('._item')
      .eq(nIndex)
      .append(getSingleReivewHtml.bind(this)(htData));
  }

  initReviewSwiper() {
    if (TMON.sDevice === 'PW' || this.bUseSlider === false) {
      return;
    }

    /* global Swiper */
    this.oSwiperReview = new Swiper('.swiper-container-p', {
      autoHeight: true,
      on: {
        slideChange: () => {
          const nDataLength = this.oModule.getData().length;
          // 슬라이드 데이터 있을때만 실행한다.
          if (nDataLength > 0) {
            // 다음 데이터를 불러온다.
            if (
              this.oSwiperReview.activeIndex >=
              nDataLength - 1 - this.NEXT_PAGE_MARGIN_COUNT
            ) {
              this.oModule.getNextData();
            }

            // 모바일의 경우 '추천'버튼 하나를 가지고 계속 사용하기 때문에 슬라이드시에 추천 개수 등을 업데이트 해줘야한다.
            if (TMON.sDevice !== 'PW') {
              this.updateRecommendElement();
            }
          
            $(window).scrollTop(0);
          }
        },
      },
    });
  }

  /**
   * 모바일의 경우 하나의 "추천" 버튼을 사용하기 때문에 슬라이드시 등에 경우 업데이트를 해준다.
   */
  updateRecommendElement() {
    const welActiveSlide = this.bUseSlider
      ? $(this.oSwiperReview.slides[this.oSwiperReview.activeIndex])
      : this.welContainer.find('._item:first');

    const sClass =
      welActiveSlide.attr('data-isRecommended') === 'Y' ? 'on' : '';
    this.welContainer
      .find('button[data-role=recommend]')
      .removeClass('on')
      .addClass(sClass)
      .find('.text')
      .html(welActiveSlide.attr('data-recommendCnt'));
  }

  /**
   * 구매옵션 펼치기
   */
  onOpenOption = e => {
    if (typeof this.htOptions.onClickShowOption === 'function') {
      this.htOptions.onClickShowOption();
    }

    $(e.currentTarget)
      .parents('[data-role=openOptionWrap]')
      .toggleClass('on');
  };

  /**
   * 추천하기
   * @param e
   */
  onRecommend = e => {
    const wel = $(e.currentTarget);
    let nReviewNo = parseInt(wel.parents('._item').attr('data-reviewNo'), 10);
    let sMemberNo = wel.parents('._item').attr('data-memberno');

    if (TMON.sDevice !== 'PW') {
      const welActiveSlide = this.bUseSlider
        ? $(this.oSwiperReview.slides[this.oSwiperReview.activeIndex])
        : this.welContainer.find('._item:first');
      nReviewNo = parseInt(welActiveSlide.attr('data-reviewNo'), 10);
      sMemberNo = welActiveSlide.attr('data-memberno');
    }

    if (typeof this.htOptions.onRecommend === 'function') {
      this.htOptions.onRecommend(nReviewNo, wel.hasClass('on'), sMemberNo);
    }
  };

  /**
   * 썸네일 이미지 마우스 오버시에 큰이미지로 보기
   * @param e
   */
  onMouseOverImage = e => {
    const wel = $(e.currentTarget);

    if (wel.hasClass('on')) {
      return;
    }

    wel
      .parents('._item:first')
      .find('[data-role=photoOver]')
      .removeClass('on');
    wel.addClass('on');
    wel
      .parents('._item:first')
      .find('[data-role=mainImage]:first')
      .attr('src', wel.attr('data-image'));
  };

  onPrevReview = () => {
    if (this.nCurrentIndex === 0) {
      return;
    }

    if (typeof this.htOptions.onClickPrevReview === 'function') {
      this.htOptions.onClickPrevReview(this.nCurrentIndex - 1);
    }

    this.showReviewSlide(this.nCurrentIndex - 1);
    this.setDisableBtn();
  };

  /**
   * 이전, 다음 버튼 disable 시킬건지
   */
  setDisableBtn() {
    const nReviewLastIndex = this.wel.find('._item').length - 1;

    if (this.nCurrentIndex === 0) {
      this.welContainer
        .find('button[data-role=prevReview]')
        .addClass('disabled')
        .prop('disabled', true);
    } else {
      this.welContainer
        .find('button[data-role=prevReview]')
        .removeClass('disabled')
        .prop('disabled', false);
    }

    if (this.nCurrentIndex === nReviewLastIndex) {
      this.welContainer
        .find('button[data-role=nextReview]')
        .addClass('disabled')
        .prop('disabled', true);
    } else {
      this.welContainer
        .find('button[data-role=nextReview]')
        .removeClass('disabled')
        .prop('disabled', false);
    }
  }

  onNextReview = () => {
    const nReviewLastIndex = this.wel.find('._item').length - 1;

    // 다음 데이터를 불러온다.
    if (this.nCurrentIndex >= nReviewLastIndex - this.NEXT_PAGE_MARGIN_COUNT) {
      this.oModule.getNextData();
    }

    if (this.nCurrentIndex + 1 > nReviewLastIndex) {
      return;
    }

    if (typeof this.htOptions.onClickNextReview === 'function') {
      this.htOptions.onClickNextReview(this.nCurrentIndex + 1);
    }

    this.showReviewSlide(this.nCurrentIndex + 1);
    this.setDisableBtn();
  };

  initImageSwiper() {
    // PC의 경우 스와이퍼를 쓰지 않는다. (썸네일 이미지에 마우스 오버시에 변함)
    if (TMON.sDevice === 'PW' || $('.swiper-container-c').length === 0) {
      return;
    }

    /* global Swiper */
    const oImageSwiper = new Swiper('.swiper-container-c', {
      nested: true,
      autoHeight: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: (oSwiper, nCurrent) => {
          $(oSwiper.el)
            .parents('._item:first')
            .find('span[data-role=pageNationCurrent]')
            .html(nCurrent);
        },
      },
    });

    if (!Array.isArray(oImageSwiper) && oImageSwiper && oImageSwiper.update) {
      this.aSwiperImage = [oImageSwiper];
    } else {
      this.aSwiperImage = oImageSwiper;
    }
  }

  hide() {
    if (this.wel) {
      this.wel.hide();
    }
    this.bShowed = false;
  }

  getRefinedDealInfo(htDealInfo) {
    if (!htDealInfo) {
      return null;
    }

    const htRefined = {
      sUrl: `${TMON.htCommonUrl.www_dealDetail}/${htDealInfo.dealNo}`,
      sTitle: htDealInfo.titleName,
      sImage: htDealInfo.imageInfo.mobile3ColImageUrl,
      sPriceTypeHtml: '',
      sOrgPrice: '',
      sPrice: '',
      sPriceOver: '',
      nDealNo: htDealInfo.dealNo,
    };

    if (
      (htDealInfo.categoryInfo.verticalType === 'LOCAL' ||
        htDealInfo.categoryInfo.verticalType === 'TOUR') &&
      htDealInfo.area
    ) {
      htRefined.sTitle = `[${htDealInfo.area}] ${htDealInfo.titleName}`;
    }

    // Price Type
    const htDiscountInfo =
      htDealInfo.priceInfo.discountInfos[
        htDealInfo.priceInfo.paymentDiscountInfoKey
      ];
    htRefined.sPrice = TMON.util.numberWithComma(htDiscountInfo.price);
    if (htDealInfo.isUniformlyPrice && htDiscountInfo.price > 0) {
      htRefined.sPriceTypeHtml = '<strong class="type">균일가</strong>';
      if (htDealInfo.priceInfo.originalPrice > htDiscountInfo.price) {
        htRefined.sOrgPrice = TMON.util.numberWithComma(
          htDealInfo.priceInfo.originalPrice
        );
      }
    } else if (
      htDiscountInfo.discountType &&
      (htDiscountInfo.discountType === 'RATE' ||
        htDiscountInfo.discountType === 'AMOUNT')
    ) {
      htRefined.sPriceTypeHtml = `<strong class="type"><span class="num">${htDiscountInfo.discountRate}<em>%</em></span></strong>`;
      htRefined.sPriceOver = htDealInfo.isDelegatePriceOver ? '~' : '';
    }

    // 딜 상세 페이지 이동 url
    if (TMON.sDevice !== 'PW') {
      if (
        htDealInfo.launchInfo &&
        htDealInfo.launchInfo.type === 'WEB_DEAL_DETAIL'
      ) {
        // 신 딜상세
        htRefined.sUrl = htDealInfo.launchInfo.url;
      } else {
        // 구 딜상세
        htRefined.sUrl = `${TMON.htCommonUrl.www_m_dealDetail}/${htDealInfo.dealNo}`;
      }
    }

    return htRefined;
  }

  render() {
    const aData = this.oModule.getData();
    if (!aData || aData.length === 0) {
      return null;
    }

    const htFirstData = aData && aData.length ? aData[0] : {};
    const htRefinedDealInfo = this.getRefinedDealInfo(htFirstData.dealInfo);

    return this.welContainer
      .append(getRenderHtml(aData, htRefinedDealInfo))
      .find('div[data-role=reviewMain]');
  }

  getReviewSlide(aReviewData) {
    return aReviewData
      .map(
        htReview =>
          `<div class="review_container swiper-slide _item"
                    data-memberNo="${htReview.memberNo}"
                    data-mainBuyNo="${htReview.mainBuyNo}"
                    data-mainDealNo="${htReview.mainDealNo}"
                    data-reviewNo="${htReview.reviewNo}"
                    data-recommendCnt="${
                      htReview.recommendCnt ? htReview.recommendCnt : 0
                    }"
                    data-isRecommended="${htReview.isRecommended ? 'Y' : 'N'}">
                    ${getSingleReivewHtml.bind(this)(htReview)}
                </div>`
      )
      .join('');
  }
}
